// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlusIcon_wrapper__r5F7u","plus":"PlusIcon_plus__DYVKj"};